import React from 'react';

import { createIcon } from '../createIcon';

function SvgValidateCircle(props: React.SVGProps<SVGSVGElement>): React.JSX.Element {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <defs>
        <path
          d="M6 0a5.99 5.99 0 00-6 6c0 3.321 2.679 6 6 6s6-2.679 6-6-2.679-6-6-6zm0 1.2c2.679 0 4.8 2.121 4.8 4.8S8.679 10.8 6 10.8A4.765 4.765 0 011.2 6c0-2.679 2.121-4.8 4.8-4.8zM4.824 8.186a.714.714 0 01-1.032-.013l-1.18-1.244a.762.762 0 01.001-1.057l-.045.046a.692.692 0 011.009.023l.725.79 2.904-2.913a.724.724 0 011.032-.003l-.046-.047a.745.745 0 01-.01 1.043L4.824 8.186z"
          id="Validate-circle_svg__a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h16v16H0z" />
        <g transform="translate(2 2)">
          <path d="M0 0h12v12H0z" />
          <use fill="currentColor" xlinkHref="#Validate-circle_svg__a" />
        </g>
      </g>
    </svg>
  );
}

export const ValidateCircleOutlinedIcon = createIcon(SvgValidateCircle, 'ValidateCircleOutlinedIcon');
